import receivablePaymentApi from "../api/receivablePayment.api";

const ReceivablePaymentService = {
  /**
   * 💰 Registrar pago de cuenta por cobrar
   * POST /api/receivable/payments
   */
  create: async (payload: any) => {
    const response = await receivablePaymentApi.add(payload);

    return response.data;
  },
};

export default ReceivablePaymentService;